export default __webpack_public_path__ + "static/media/testimonial_new_2.43e53413.svg";